import PropTypes from 'prop-types';
import { compose, setPropTypes, withHandlers, withPropsOnChange, withState } from 'recompose';
import { connect } from 'react-redux';
import OwnerPaymentCard from './OwnerPaymentCard';
import {
  createOwnerPaymentCard,
  updateOwnerPaymentCard,
} from '../../main/payment/actions';
import withCurrency from '../hoc/withCurrency';
import { canUserModifyBankAccounts } from '../helpers/users';
import { getIsAdminUser } from '../../auth/selectors';
import withFetchOwnerPaymentCard from './withFetchOwnerPaymentCard';
import confirmModal from '../confirmModal';

const OwnerPaymentCardContainer = compose(
  withCurrency,
  setPropTypes({
    card: PropTypes.shape({
      id: PropTypes.string,
      brand: PropTypes.string,
      last4: PropTypes.string,
      paymentCustomerChangeRequired: PropTypes.bool,
      updatedAt: PropTypes.string,
      ownerId: PropTypes.string,
      ownerType: PropTypes.string,
    }),
  }),
  withState('showInput', 'setShowInput', true),
  connect(
    (state, ownProps) => ({
      canModifyPaymentCard: canUserModifyBankAccounts(state.auth.permissions) || getIsAdminUser(state),
      card: !ownProps.showInput ? ownProps.card : null,
      paymentCustomerChangeRequired: ownProps.card?.paymentCustomerChangeRequired,
      updatedAt: ownProps.card?.updatedAt,
      buttonText: ownProps.card?.id ? 'update' : 'add card',
      cardId: ownProps.card?.id,
      ownerType: ownProps.card?.ownerType,
      ownerId: ownProps.card?.ownerId,
    }),
    {
      createCard: createOwnerPaymentCard,
      updateCard: updateOwnerPaymentCard,
    }
  ),
  withHandlers({
    changeCard: props => async (token) => {
      if (props.cardId) {
        const confirmed = await confirmModal({
          type: 'yesno',
          title: 'Update card',
          message: 'Adding a new card will replace the current one. Do you want to proceed?',
        });

        if (confirmed) {
          return props.updateCard(props.ownerId, props.ownerType, token);
        }

        props.setShowInput(false);
        return Promise.resolve(null);
      }

      return props.createCard(props.ownerId, props.ownerType, token);
    },
    removeCard: props => () => props.setShowInput(true),
  }),
  withPropsOnChange(['updatedAt'], (props) => {
    if (props.cardId) {
      props.setShowInput(false);
    }
  }),
)(OwnerPaymentCard);

export default withFetchOwnerPaymentCard(OwnerPaymentCardContainer);
